"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    createHandleGatewayRequest: ()=>createHandleGatewayRequest
});
const external_gateway_service_js_namespaceObject = require("./gateway.service.js");
const TTP_GATEWAY_KEYS = [
    'ttp-eu',
    'ttp-eu-de',
    'ttp-eu-gcp',
    'ttp-eu-useast2b',
    'ttp-us-limited'
];
const createHandleGatewayRequest = (param)=>{
    let { rewrittenDomainID: mayPromiseRewrittenDomainID = [], rewriteRules = [], defaultDomainID, defaultGatewayKey, defaultVRegion, rewriteAll, gatewayService = external_gateway_service_js_namespaceObject.gatewayService, followBytecloudDowngrade } = param;
    const handleGatewayRequest = async (param)=>{
        let { url, certainDomainID, certainGatewayKey, certainVRegion } = param;
        var _rewriteRule_rewrittenDomainID;
        if (!(null == url ? void 0 : url.startsWith('/web_api/')) && !(null == url ? void 0 : url.match(/^\/api\/v\d+\//))) {
            try {
                console.warn('%cByteCloudGateway', 'background:blue;border-radius: 0.5em;color:white;font-weight:bold;padding:2px 0.5em', "\u5F53\u524D\u8BF7\u6C42\u4E0D\u7B26\u5408\u5B57\u8282\u4E91\u7F51\u5173\u89C4\u5219\uFF0C\u5C06\u6309\u7167\u5F53\u524D origin \u53D1\u8D77\u8BF7\u6C42");
            } catch (error) {
                console.error(error);
            }
            return;
        }
        const [rewrittenDomainID, targetDomainID, vRegion, initialTargetGatewayKey] = await Promise.all([
            await mayPromiseRewrittenDomainID,
            certainDomainID || await gatewayService.getDomainIDByGatewayKey(certainGatewayKey) || defaultDomainID || await gatewayService.getDomainIDByGatewayKey(defaultGatewayKey),
            ('string' == typeof certainVRegion ? certainVRegion : await (null == certainVRegion ? void 0 : certainVRegion())) || ('string' == typeof defaultVRegion ? defaultVRegion : await (null == defaultVRegion ? void 0 : defaultVRegion())),
            await gatewayService.getTargetGatewayKey({
                certainDomainID,
                defaultDomainID,
                certainGatewayKey,
                defaultGatewayKey
            })
        ]);
        let targetGatewayKey = initialTargetGatewayKey;
        const rewriteRule = null == rewriteRules ? void 0 : rewriteRules.find((rule)=>{
            if ('string' == typeof rule.match) return url.startsWith(rule.match);
            return rule.match.test(url);
        });
        const requiredOGProxyModeHeadersGatewayKeys = await gatewayService.getRequiredOGProxyModeHeadersGatewayKeys() || TTP_GATEWAY_KEYS;
        const withOGCommonPathMode = targetGatewayKey ? requiredOGProxyModeHeadersGatewayKeys.includes(targetGatewayKey) : false;
        if (rewriteRule && targetDomainID && ((null == rewrittenDomainID ? void 0 : rewrittenDomainID.includes(targetDomainID)) || (null == (_rewriteRule_rewrittenDomainID = rewriteRule.rewrittenDomainID) ? void 0 : _rewriteRule_rewrittenDomainID.includes(targetDomainID)) || await rewriteAll || followBytecloudDowngrade && await gatewayService.getDowngrade(targetDomainID))) {
            const targetUrl = await rewriteRule.rewrite({
                originalUrl: url,
                targetDomainID,
                vRegion
            });
            if (targetUrl) return {
                url: targetUrl,
                jwtUniqueKey: await gatewayService.getJwtUniqueKeyByGatewayKey(targetGatewayKey) || 'currentOrigin',
                withJwt: 'ttp-us-limited' === targetDomainID || !rewriteRule.disableJwt,
                withCredentials: 'ttp-us' === targetDomainID,
                withOGCommonPathMode
            };
        }
        const remoteRewriteConfig = await gatewayService.getDefaultRewriteConfig();
        const remoteRewriteRule = remoteRewriteConfig.find((rule)=>{
            const isURLMatch = checkRemoteURLMatch(rule, url);
            if (Array.isArray(rule.matchVRegions)) return isURLMatch && 'string' == typeof vRegion && rule.matchVRegions.includes(vRegion);
            return isURLMatch;
        });
        if (remoteRewriteRule) {
            var _remoteRewriteRule_rewriteGatewayKey;
            if (targetDomainID) {
                var _remoteRewriteRule_rewriteURL, _remoteRewriteRule_rewriteURL_replaceValue, _remoteRewriteRule_rewriteURL1;
                const searchValue = null == (_remoteRewriteRule_rewriteURL = remoteRewriteRule.rewriteURL) ? void 0 : _remoteRewriteRule_rewriteURL.searchValue;
                const replaceValue = null == (_remoteRewriteRule_rewriteURL1 = remoteRewriteRule.rewriteURL) ? void 0 : null == (_remoteRewriteRule_rewriteURL_replaceValue = _remoteRewriteRule_rewriteURL1.replaceValue) ? void 0 : _remoteRewriteRule_rewriteURL_replaceValue[targetDomainID];
                if (replaceValue && searchValue) {
                    var _remoteRewriteRule_rewriteURL2;
                    const targetUrl = url.replace(searchValue, replaceValue);
                    return {
                        url: targetUrl,
                        jwtUniqueKey: await gatewayService.getJwtUniqueKeyByGatewayKey(targetGatewayKey) || 'currentOrigin',
                        withJwt: 'ttp-us-limited' === targetDomainID || !(null == (_remoteRewriteRule_rewriteURL2 = remoteRewriteRule.rewriteURL) ? void 0 : _remoteRewriteRule_rewriteURL2.disableJwt),
                        withCredentials: 'ttp-us' === targetDomainID,
                        withOGCommonPathMode
                    };
                }
            }
            if (targetGatewayKey && (null == (_remoteRewriteRule_rewriteGatewayKey = remoteRewriteRule.rewriteGatewayKey) ? void 0 : _remoteRewriteRule_rewriteGatewayKey[targetGatewayKey])) {
                var _remoteRewriteRule_rewriteGatewayKey1;
                targetGatewayKey = null == (_remoteRewriteRule_rewriteGatewayKey1 = remoteRewriteRule.rewriteGatewayKey) ? void 0 : _remoteRewriteRule_rewriteGatewayKey1[targetGatewayKey];
            }
        }
        const gatewayItem = await gatewayService.getGatewayItemByGatewayKey(targetGatewayKey);
        if (gatewayItem) return {
            url: `${gatewayItem.origin}${url}`,
            jwtUniqueKey: gatewayItem.jwtUniqueKey,
            withJwt: gatewayItem.withJwt,
            withCredentials: gatewayItem.withCredentials,
            withOGCommonPathMode
        };
        return {
            url,
            jwtUniqueKey: 'currentOrigin',
            withJwt: false,
            withCredentials: true,
            withOGCommonPathMode
        };
    };
    return handleGatewayRequest;
};
function checkRemoteURLMatch(rule, url) {
    if ('string' === rule.matchType) return url.startsWith(rule.match);
    return new RegExp(rule.match).test(url);
}
exports.createHandleGatewayRequest = __webpack_exports__.createHandleGatewayRequest;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "createHandleGatewayRequest"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
